import { Component, OnInit, signal } from '@angular/core';
import { PaymentService, ProductDisplay, Subscription } from '../payment.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cart-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cart-view.component.html',
  styleUrls: ['./cart-view.component.css']
})
export class CartViewComponent implements OnInit{
  subs: Subscription[];
  selectedSub: Subscription;
  products = signal<ProductDisplay[]>([]);
  selectedProduct = signal<ProductDisplay>(null);

  constructor(private paymentService: PaymentService){

  }

  async goToCheckout(){
    const session = await this.paymentService.getCheckoutSession(this.selectedProduct());
    if(session){
      await this.paymentService.checkout(session.url);
    }
  }

  selectProduct(product: ProductDisplay){
    this.selectedProduct.set(product);
  }

  async ngOnInit(): Promise<void> {
    this.subs = [];
    this.selectedSub = this.subs[0];
    const items = await this.paymentService.getProducts();
    this.products.set(items);
    this.selectedProduct.set(items[0]);
  }

}
